import * as i0 from '@angular/core';
import { Directive, HostBinding, Input, NgModule } from '@angular/core';
import { defineCustomElements } from '@ispui/tooltip/loader';

class ISPUITooltipValueAccessor {
}
ISPUITooltipValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUITooltipValueAccessor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ISPUITooltipValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUITooltipValueAccessor, selector: "ispui-tooltip", inputs: { width: "width", preset: "preset", tooltipClass: ["tooltip-class", "tooltipClass"], attachSelector: ["attach-selector", "attachSelector"], attachNode: ["attach-node", "attachNode"], titleText: ["title-text", "titleText"], placement: "placement", placementOrder: ["placement-order", "placementOrder"], animation: "animation", offsets: "offsets", mouseEnterDelay: ["mouse-enter-delay", "mouseEnterDelay"], mouseLeaveDelay: ["mouse-leave-delay", "mouseLeaveDelay"], viewportSelector: ["viewport-selector", "viewportSelector"], scrollSelector: ["scroll-selector", "scrollSelector"], viewportNode: ["viewport-node", "viewportNode"], ellipsis: "ellipsis", disabled: "disabled", tooltipWidth: "tooltipWidth", asHtml: "asHtml", disabledArrow: "disabledArrow" }, host: { properties: { "attr.width": "this.width", "attr.preset": "this.preset", "attr.tooltip-class": "this.tooltipClass", "attr.attach-selector": "this.attachSelector", "attachNode": "this.attachNode", "attr.title-text": "this.titleText", "attr.placement": "this.placement", "placementOrder": "this.placementOrder", "attr.animation": "this.animation", "attr.offsets": "this.offsets", "attr.mouse-enter-delay": "this.mouseEnterDelay", "attr.mouse-leave-delay": "this.mouseLeaveDelay", "attr.viewport-selector": "this.viewportSelector", "attr.scroll-selector": "this.scrollSelector", "viewportNode": "this.viewportNode", "attr.ellipsis": "this.ellipsis", "attr.disabled": "this.disabled", "attr.tooltip-width": "this.tooltipWidth", "attr.as-html": "this.asHtml", "attr.disabled-arrow": "this.disabledArrow" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUITooltipValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ispui-tooltip',
                }]
        }], propDecorators: { width: [{
                type: HostBinding,
                args: ['attr.width']
            }, {
                type: Input
            }], preset: [{
                type: HostBinding,
                args: ['attr.preset']
            }, {
                type: Input,
                args: ['preset']
            }], tooltipClass: [{
                type: HostBinding,
                args: ['attr.tooltip-class']
            }, {
                type: Input,
                args: ['tooltip-class']
            }], attachSelector: [{
                type: HostBinding,
                args: ['attr.attach-selector']
            }, {
                type: Input,
                args: ['attach-selector']
            }], attachNode: [{
                type: HostBinding,
                args: ['attachNode']
            }, {
                type: Input,
                args: ['attach-node']
            }], titleText: [{
                type: HostBinding,
                args: ['attr.title-text']
            }, {
                type: Input,
                args: ['title-text']
            }], placement: [{
                type: HostBinding,
                args: ['attr.placement']
            }, {
                type: Input
            }], placementOrder: [{
                type: HostBinding,
                args: ['placementOrder']
            }, {
                type: Input,
                args: ['placement-order']
            }], animation: [{
                type: HostBinding,
                args: ['attr.animation']
            }, {
                type: Input
            }], offsets: [{
                type: HostBinding,
                args: ['attr.offsets']
            }, {
                type: Input
            }], mouseEnterDelay: [{
                type: HostBinding,
                args: ['attr.mouse-enter-delay']
            }, {
                type: Input,
                args: ['mouse-enter-delay']
            }], mouseLeaveDelay: [{
                type: HostBinding,
                args: ['attr.mouse-leave-delay']
            }, {
                type: Input,
                args: ['mouse-leave-delay']
            }], viewportSelector: [{
                type: HostBinding,
                args: ['attr.viewport-selector']
            }, {
                type: Input,
                args: ['viewport-selector']
            }], scrollSelector: [{
                type: HostBinding,
                args: ['attr.scroll-selector']
            }, {
                type: Input,
                args: ['scroll-selector']
            }], viewportNode: [{
                type: HostBinding,
                args: ['viewportNode']
            }, {
                type: Input,
                args: ['viewport-node']
            }], ellipsis: [{
                type: HostBinding,
                args: ['attr.ellipsis']
            }, {
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['attr.disabled']
            }, {
                type: Input
            }], tooltipWidth: [{
                type: HostBinding,
                args: ['attr.tooltip-width']
            }, {
                type: Input
            }], asHtml: [{
                type: HostBinding,
                args: ['attr.as-html']
            }, {
                type: Input
            }], disabledArrow: [{
                type: HostBinding,
                args: ['attr.disabled-arrow']
            }, {
                type: Input
            }] } });

class ISPUITooltipWrapperValueAccessor {
}
ISPUITooltipWrapperValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUITooltipWrapperValueAccessor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ISPUITooltipWrapperValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUITooltipWrapperValueAccessor, selector: "ispui-tooltip-wrapper", inputs: { tooltipSelectorPrefix: "tooltipSelectorPrefix", globalDebounce: "globalDebounce" }, host: { properties: { "attr.tooltip-selector-prefix": "this.tooltipSelectorPrefix", "attr.global-debounce": "this.globalDebounce" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUITooltipWrapperValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ispui-tooltip-wrapper',
                }]
        }], propDecorators: { tooltipSelectorPrefix: [{
                type: HostBinding,
                args: ['attr.tooltip-selector-prefix']
            }, {
                type: Input
            }], globalDebounce: [{
                type: HostBinding,
                args: ['attr.global-debounce']
            }, {
                type: Input
            }] } });

class ISPUITooltipModule {
    constructor() {
        defineCustomElements(window);
    }
}
ISPUITooltipModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUITooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ISPUITooltipModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUITooltipModule, declarations: [ISPUITooltipWrapperValueAccessor, ISPUITooltipValueAccessor], exports: [ISPUITooltipWrapperValueAccessor, ISPUITooltipValueAccessor] });
ISPUITooltipModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUITooltipModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUITooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ISPUITooltipWrapperValueAccessor, ISPUITooltipValueAccessor],
                    exports: [ISPUITooltipWrapperValueAccessor, ISPUITooltipValueAccessor],
                }]
        }], ctorParameters: function () { return []; } });

/**
 * Generated bundle index. Do not edit.
 */

export { ISPUITooltipModule, ISPUITooltipValueAccessor, ISPUITooltipWrapperValueAccessor };
